import { AmenitySvg, AmenitySvgProps } from "./AmenitySvg";

export function SaunaIcon(props: AmenitySvgProps) {
  return (
    <AmenitySvg {...props}>
      <path
        d="M6.6644 17.9864L6 14H24L23.3356 17.9864C22.9365 20.3809 22.737 21.5781 21.8977 22.2891C21.0585 23 19.8448 23 17.4172 23H12.5828C10.1552 23 8.94149 23 8.10226 22.2891C7.26302 21.5781 7.06348 20.3809 6.6644 17.9864Z"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.6 11C22.1333 10.4477 22.1333 9.55228 21.6 9C21.0667 8.44772 21.0667 7.55228 21.6 7M18.4 11C18.9333 10.4477 18.9333 9.55228 18.4 9C17.8667 8.44772 17.8667 7.55228 18.4 7"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
      />
      <path
        d="M18.6 11C19.1333 10.4477 19.1333 9.55228 18.6 9C18.0667 8.44772 18.0667 7.55228 18.6 7M15.4 11C15.9333 10.4477 15.9333 9.55228 15.4 9C14.8667 8.44772 14.8667 7.55228 15.4 7"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
      />
      <path
        d="M6 14H5M24 14H25"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </AmenitySvg>
  );
}
